import { of } from 'rxjs';
import { DialogResult } from '../../../models/dialog/dialog-result.model';
import { DialogButton } from '../../../enums/dialog-button.enum';

export class MatDialogMock {
  public dialogResult = new DialogResult(DialogButton.OK);

  public open() {
    return {
      afterClosed: () => of(this.dialogResult)
    };
  }
}
